export default __webpack_public_path__ + "static/logo-d3423a609e90e2df4421f35452f07bd1.png";